import { useTrackEvent } from '@optimizely/react-sdk';

import { logger } from 'Services/logger/logger';

import { useOptimizelyUserAttributes } from '../useOptimizelyUserAttributes';

interface UseTrackEventWhenReadyParams {
	attributes?: Record<string, Nullable<string | boolean>>;
	condition?: boolean;
	overrideUserId?: string;
}

type UseTrackEventWhenReady = (params: UseTrackEventWhenReadyParams) => void;

const handleTrackEventError = (e?: unknown) => {
	const error = e instanceof Error ? e : new Error('There was an error when tracking event');
	logger.warn({ error, message: error.message, scope: 'useTrackEventWhenReady' });
};

export const useTrackEventWhenReady = (event: string): UseTrackEventWhenReady => {
	const [track, clientReady, didTimeout] = useTrackEvent();
	const userAttributes = useOptimizelyUserAttributes();

	return ({ attributes = {}, condition = true, overrideUserId }) => {
		const isClientReady = clientReady && !didTimeout;
		if (condition && isClientReady) {
			setTimeout(() => {
				try {
					track(event, overrideUserId, {
						...userAttributes,
						...attributes,
					});
				} catch (e) {
					handleTrackEventError(e);
				}
			});
		}
		if (!isClientReady) {
			handleTrackEventError();
		}
	};
};
